import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import TitleComponent from '../TitleComponent';

const IndicatorContainer = styled.div`
  min-width: 170px;
  margin-top: 20px;
  display: flex;

  .titlePosition {
    @media (max-width: 1250px) {
      display: inline-flex;
      gap: 4px;
    }
  }

  @media (max-width: 1250px) {
    min-width: 150px;
    margin-top: 8px;
  }
`;

const MarketNotebooksIndicator = () => (
  <IndicatorContainer>
    <TitleComponent>
      <div className="titlePosition">
        <p>{I18n.t('dashboard.labelIndicatorMarket1Line').toUpperCase()}</p>
        <p>{I18n.t('dashboard.labelIndicatorMarket2Line').toUpperCase()}</p>
      </div>
    </TitleComponent>
  </IndicatorContainer>
);

export default MarketNotebooksIndicator;
